import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { RunnerEvent, runnerEventList } from "../../../../../api/event";
import {
  EventComponentWrapper,
  EventComponentItemWrapper,
  EventComponentFilter,
  EventComponentListWrapper,
} from "./style";

const EventComponent = () => {
  const history = useHistory();
  const [selectedEventList, setSelectedEventList] = useState<
    "전체" | "진행중" | "종료"
  >("전체");
  const [list, setList] = useState<RunnerEvent[]>([]);

  useEffect(() => {
    getData();
  }, [selectedEventList]);

  const getData = async () => {
    let list: RunnerEvent[] = [];
    if (selectedEventList === "전체") {
      list = await runnerEventList({ type: "EVENT" });
    } else if (selectedEventList === "진행중") {
      list = await runnerEventList({ endYn: "N", type: "EVENT" });
    } else {
      list = await runnerEventList({ endYn: "Y", type: "EVENT" });
    }
    list.sort(
      (a, b) => new Date(a.closeAt).getTime() - new Date(b.closeAt).getTime()
    );
    setList(list);
  };

  return (
    <EventComponentWrapper>
      <EventComponentFilter>
        {["전체", "진행중", "종료"].map((x) => (
          <div
            className={`item ${x === selectedEventList ? "selected" : ""}`}
            onClick={() => {
              setSelectedEventList(x as any);
            }}
            key={x}
          >
            {x}
          </div>
        ))}
      </EventComponentFilter>
      <EventComponentListWrapper>
        {list.map((item, index) => (
          <EventComponentItemWrapper
            key={index}
            onClick={() => {
              history.push(`/event/detail/${item.id}`);
            }}
          >
            {item.url && <img src={item.url} alt="event" />}
          </EventComponentItemWrapper>
        ))}
      </EventComponentListWrapper>
    </EventComponentWrapper>
  );
};

export default EventComponent;
